import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Box,
  Checkbox,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TextField,
  Modal,
  TableContainer,
  TablePagination,
  FormControl,
  Select,
  OutlinedInput,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import api from 'src/services/BaseService';
import { tokenService } from 'src/services';
import CreateWorkOrderModal from 'src/components/modals/CreateWorkOrderModal';
import DeliveryModal from 'src/components/modals/DeliveryModal';
import './muhaberatOutput.css';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: '', alignRight: false },
  { id: 'no', label: 'No', alignRight: false },
  { id: 'barcode', label: 'Barkod', alignRight: false },
  { id: 'title', label: 'Kişi', alignRight: false },
  { id: 'corporation', label: 'Firma', alignRight: false },
  { id: 'corporationID', label: 'Firma ID', alignRight: false },
  //   { id: 'from', label: 'Çıkış Noktası', alignRight: false },
  //   { id: 'to', label: 'Varış Noktası', alignRight: false },
  { id: 'deliverValue', label: 'Kargo Durumu', alignRight: false },
  { id: 'createdDateTime', label: 'Oluşturulma Tarihi', alignRight: false },
  { id: 'shipmentFirm', label: 'Kargo Firması', alignRight: false },
  { id: '', label: 'İşlemler' },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StatusList = [
  { label: 'Şubede', id: 5 },
  { label: 'Tamamlandı', id: 1 },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function MuhaberatOutput() {
  const customer = useSelector((state) => state.customerReducer);
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [allDatas, setAllDatas] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedCargoStatus, setSelectedCargoStatus] = useState([]);
  const [locations, setLocations] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [firm, setFirm] = useState('');
  const [barcode, setBarcode] = useState('');
  const [cargo, setCargo] = useState('');

  const [handoverModal, setHandoverModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState('');

  const [confirmCode, setConfirmCode] = useState('');
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);

  // Service
  function getLocations(directions) {
    api
      .post('locations/get-locations', {
        branchID: customer?.customer?.branchID,
      })
      .then((response) => {
        if (response.data.status) {
          const permutations = [];

          for (let i = 0; i < response.data.result?.length; i++) {
            for (let j = 0; j < response.data.result?.length; j++) {
              if (i !== j) {
                permutations.push({
                  title: `${response.data.result[i].title} → ${response.data.result[j].title}`,
                  handle: 'StoreToStore',
                  type: 'new',
                  from: response.data.result[i].locationID,
                  to: response.data.result[j].locationID,
                });
              }
            }
          }

          directions = directions.concat(permutations);
          setLocations(directions);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }

  function getDirections() {
    api
      .get('directions/get')
      .then((response) => {
        if (response.data.status) {
          getLocations(
            response.data.result.filter((x) => x.handle != 'StoreToStore')
          );
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }

  function getFilteredOrderList() {
    console.log(customer?.customer?.branchID, customer?.customer?.id);
    api
      .post('posts/get', {
        branchID: customer?.customer?.branchID || null,
        mallID: customer?.customer?.id || null,
        status:
          selectedCargoStatus && selectedCargoStatus.length > 0
            ? selectedCargoStatus?.map((x) => x.id)
            : StatusList.filter((x) => x.id != 0).map((x) => x.id),
        startDate: startDate
          ? moment(startDate).format('DD-MM-YYYY')
          : startDate,
        endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : endDate,
      })
      .then((response) => {
        if (response.data.status) {
          console.log(response.data.result);
          setOrderList(response.data.result);
          setAllDatas(response.data.result);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => toast.error(error.message));
  }

  function exportToExcel() {
    let temp1 = orderList?.map((x, index) => {
      let a = {
        id: index + 1,
        barcode: x.barcode,
        title: x.title,
        from: x.from.title,
        to: x.to.title,
        deliverValue: x.deliverValue ? 'Başarlı' : 'Başarısız',
        createdDateTime: moment(new Date(Number(x.createdDateTime))).format(
          'DD/MM/YYYY'
        ),
      };
      return a;
    });
    api
      .post('excel/export', {
        type: 'excel',
        content: temp1,
        header: {
          ID: 'number',
          'Kargo Takip No': 'string',
          'Firma/Kişi': 'string',
          'Firma ID': 'string',
          //   'Nokta Adı Çıkış': 'string',
          //   'Nokta Adı Varış': 'string',
          'Kargo Durumu': 'string',
          'Oluşturulma Tarihi': 'string',
          'Kargo Firması': 'string',
        },
        sheetTitle: 'İşler',
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.status) {
          window.open('http://' + response.data.result, '_blank');
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  }

  useEffect(() => {
    getFilteredOrderList();
    getDirections();
  }, [customer]);

  function clearFilters() {
    setStartDate(null);
    setEndDate(null);
    setSelectedCargoStatus([]);
    setFirm('');
    setBarcode('');
    getFilteredOrderList();
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCargoStatus(value);
  };

  const handleCheckboxChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];

    if (selectedIndex === -1) {
      newSelected.push(id);
    } else {
      newSelected.splice(selectedIndex, 1);
    }

    console.log('liste: ', newSelected);
    setSelected(newSelected);
    //All İtems need to be sent to component Delivery Modal for exporting function into modal
    // setSelectedItems([...selectedItems, row]);
  };

  const selectAll = () => {
    const pageStartIndex = page * rowsPerPage;
    const pageEndIndex = pageStartIndex + rowsPerPage;

    const selectedIds = orderList
      .slice(pageStartIndex, pageEndIndex)
      .filter((row) => row.status === '5')
      .map((row) => row.id);

    setSelected(selectedIds);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = orderList?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const filterByFirm = (text) => {
    const firmName = text.toLowerCase();
    const filteredOrders = allDatas.filter((item) =>
      item.branchTitle.toLowerCase().includes(firmName)
    );
    setFirm(firmName);
    setOrderList(filteredOrders);
  };

  const filterByBarcode = (barcodeNo) => {
    const filteredOrders = allDatas.filter(
      (item) => item.barcode.indexOf(barcodeNo) !== -1
    );
    setBarcode(barcodeNo);
    setOrderList(filteredOrders);
  };

  const filterByCargo = (text) => {
    const cargoFirm = text.toLowerCase();
    const filteredOrders = allDatas.filter((item) =>
      item.shipmentFirm.toLowerCase().includes(cargoFirm)
    );
    setCargo(cargoFirm);
    setOrderList(filteredOrders);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orderList.length) : 0;

  const filteredOrders = applySortFilter(
    orderList,
    getComparator(order, orderBy),
    filterName
  );

  const isNotFound = !filteredOrders.length && !!filterName;

  const handleOpenDeliveryModal = (id) => {
    // Sadece tıklanan öğenin id'sini seçili olarak işaretliyoruz.
    setSelected([id]);
    console.log('selectedOrder güncellendi: ', id);
    setHandoverModal(true);
  };

  const handleCloseDeliveryModal = () => {
    setHandoverModal(false);
  };

  const handleBack = () => {
    setSelectedOrder(null);
  };

  const completeDeliver = (code) => {
    const selectedObjects = selected?.map((item) => {
      return { postID: item, status: 1 };
    });
    if (code === confirmCode) {
      // change status
      api.post('posts/change-status', selectedObjects).then((response) => {
        console.log('change status response: ', response.data);
        if (response.data.status) {
          setHandoverModal(false);
          getFilteredOrderList();
          setSuccessModalOpen(true);
        } else {
          console.log('change status false döndü');
        }
      });
    } else {
      console.log('Uyuşmuyor.');
      toast.error('Doğrulama kodu hatalıdır. Lütfen tekrar deneyin.');
    }
  };

  const handleDeliver = (name, lastname, phone, note) => {
    console.log(selected, name, lastname, phone, note);
    api
      .post('handover/malllogistics/create', {
        postID: selected,
        message: `${selected?.length} adet gönderiyi teslim alabilmeniz için {code} kodunu yetkiliye veriniz`,
        name: name,
        lastname: lastname,
        phone: phone,
        note: note,
      })
      .then((response) => {
        console.log(response.data);
        setConfirmCode(response.data.result.code);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Helmet>
        <title> Muhaberat Çıkış | Easy Point Panel </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Muhaberat Çıkış
          </Typography>
          {['store:manageroperations', 'store:operations'].includes(
            tokenService.getUser()?.accountCategory +
              ':' +
              tokenService
                .getUser()
                ?.frontAuth?.map((x) => x)
                .join('')
          ) && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setOpenCreateModal(true)}
            >
              İş Emri Oluştur
            </Button>
          )}
        </Stack>

        <Card>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            paddingY={2}
            paddingX={1}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{ marginRight: '8px' }}
                format="DD/MM/YYYY"
                label="Başlangıç Tarihi"
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{ marginRight: '8px' }}
                format="DD/MM/YYYY"
                label="Bitiş Tarihi"
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
              />
            </LocalizationProvider>

            <Stack
              mr={1}
              direction="column"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <FormControl sx={{ minWidth: 250 }}>
                <Select
                  sx={{ marginRight: '8px' }}
                  multiple
                  displayEmpty
                  value={selectedCargoStatus}
                  input={<OutlinedInput />}
                  onChange={handleChange}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Kargo Durumu</em>;
                    }

                    return selected.map((x) => x?.label).join(', ');
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {StatusList.map((x) => (
                    <MenuItem key={x.id} value={x}>
                      {x.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Button
              sx={{ marginRight: '8px' }}
              variant="contained"
              color="info"
              onClick={() => getFilteredOrderList()}
            >
              Filtrele
            </Button>

            <Button
              sx={{ marginRight: '8px' }}
              variant="contained"
              color="error"
              onClick={() => clearFilters()}
            >
              Temizle
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={() => exportToExcel()}
            >
              Excele aktar
            </Button>
          </Stack>

          <Button
            sx={{ marginRight: '8px', marginTop: 3 }}
            variant="contained"
            color="primary"
            onClick={selectAll}
          >
            Hepsini Seç
          </Button>
          <Button
            sx={{ marginRight: '8px', marginTop: 3 }}
            variant="contained"
            color="primary"
            onClick={() => setSelected([])}
          >
            Hepsini Kaldır
          </Button>
          <TextField
            label="Barkod"
            variant="outlined"
            value={barcode}
            onChange={(e) => filterByBarcode(e.target.value)}
            sx={{ mt: 2, marginRight: '8px' }}
          />
          <TextField
            label="Firma"
            variant="outlined"
            value={firm}
            onChange={(e) => filterByFirm(e.target.value)}
            sx={{ mt: 2, marginRight: '8px' }}
          />
          <TextField
            label="Kargo Firması"
            variant="outlined"
            value={cargo}
            onChange={(e) => filterByCargo(e.target.value)}
            sx={{ mt: 2 }}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={orderList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredOrders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const {
                        id,
                        barcode,
                        branchTitle,
                        status,
                        dataJSON,
                        customer,
                        // from,
                        // to,
                        deliverValue,
                        createdDateTime,
                      } = row;
                      const selectedUser = selected.indexOf(barcode) !== -1;

                      return (
                        <TableRow
                          hover
                          key={index}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedUser}
                        >
                          {row.status === '5' ? (
                            <TableCell align="left">
                              <Checkbox
                                checked={selected.indexOf(row.id) !== -1}
                                onChange={(e) =>
                                  handleCheckboxChange(e, row.id)
                                }
                              />
                            </TableCell>
                          ) : (
                            <div />
                          )}
                          <TableCell align="left">{index + 1}</TableCell>
                          <TableCell align="left">{barcode}</TableCell>
                          <TableCell align="left">
                            {dataJSON?.customerName}
                          </TableCell>
                          <TableCell align="left">{branchTitle}</TableCell>
                          <TableCell align="left">
                            {customer?.corporationID}
                          </TableCell>
                          <TableCell align="left">
                            {status === '5' ? 'Şubede' : 'Teslim Edildi'}
                          </TableCell>
                          <TableCell align="left">
                            {moment
                              .unix(createdDateTime)
                              .format('DD/MM/YYYY HH:mm')}
                          </TableCell>
                          <TableCell align="left">
                            {dataJSON?.shipmentFirm}
                          </TableCell>

                          <TableCell align="left">
                            {row.status === '5' ? (
                              <Button
                                onClick={() => handleOpenDeliveryModal(row.id)}
                              >
                                {/* <Iconify icon={'mdi:send'} sx={{ mr: 2 }} /> */}
                                Teslim Et
                              </Button>
                            ) : (
                              <div />
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete
                            words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={orderList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      {openCreateModal && (
        <CreateWorkOrderModal
          openCreateModal={openCreateModal}
          onCreateModal={() => setOpenCreateModal(false)}
          customer={customer}
          locations={locations}
        />
      )}

      {handoverModal && (
        <DeliveryModal
          open={handoverModal}
          count={selected?.length}
          onClose={handleCloseDeliveryModal}
          onBack={handleBack}
          onDeliver={handleDeliver}
          onComplete={completeDeliver}
          selectedItems={selectedItems}
        />
      )}

      {selected?.length > 0 && (
        <Box className="bottom-center-container">
          <Button
            variant="contained"
            color="primary"
            className="bottom-center-button"
            onClick={() => setHandoverModal(true)}
          >
            ({selected?.length}) Teslim Et
          </Button>
        </Box>
      )}

      <Modal
        open={isSuccessModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <CheckCircleIcon sx={{ color: 'green', fontSize: 64 }} />
          <Typography variant="h6">
            {selected?.length} adet gönderi başarıyla teslim edildi.
          </Typography>
          <Button
            onClick={() => {
              setSuccessModalOpen(false);
              window.location.reload();
            }}
          >
            Tamam
          </Button>
        </Box>
      </Modal>
    </>
  );
}
